module.exports = __webpack_public_path__ + "media/application/images/2023-9001-b8f21373f4fd875a6b63a4ffaf1bf886.jpg";